import React from 'react';
import { hooks } from '@lifesize/clients.sdk';
import { connect } from 'react-redux';
import { streamActions } from '@lifesize/nucleus';
import AudioButton from 'components/AudioButton/AudioButton';
import _get from 'lodash/get';
import { audioUnmuteByUser } from 'actions/Call';
import { WEB_CONFERENCE_DISABLED } from 'constants/Call';

const mapDispatchToProps = dispatch => ({
  onSwitchToComputerAudio: () => {
    dispatch({ type: WEB_CONFERENCE_DISABLED });
    dispatch(streamActions.setAudioMuteState(false));
  },
  onAudioMuteClick: (mute, isMutedByServer) => {
    if (isMutedByServer) dispatch(audioUnmuteByUser(true));
    dispatch(streamActions.setAudioMuteState(mute));
  }
});

function mapStateToProps(state, ownProps) {
  const isWebConferencing = _get(state, 'app.call.isWebConference');
  const isAudioMuted = _get(ownProps, 'media.localAudioMuted');
  const isMinimized = _get(state, 'app.inCallVideo.isMinimized');
  const notification = _get(state, 'app.notification.pill');
  const hasAudioDevices = !!_get(ownProps, 'devices', []).find(d => _get(d, 'kind') === 'audioinput');
  const microphoneDeviceId = _get(ownProps, 'media.audioDevice.deviceId');

  return {
    ...ownProps,
    isWebConferencing,
    isMinimized,
    notification,
    isAudioMuted,
    hasAudioDevices,
    microphoneDeviceId,
  };
}

const ConnectedComponent = connect(mapStateToProps, mapDispatchToProps)(AudioButton);

const FunctionalWrapper = (props) => {
  const isConnected = hooks.useCallConnected();
  const media = hooks.useMedia();
  const devices = hooks.useDevices();
  const isModerator = hooks.useIsCurrentUserModerator();
  const currentUserParticipant = hooks.useCurrentUserParticipant();
  return (
    <ConnectedComponent
      {...props}
      isMutedByServer={currentUserParticipant && currentUserParticipant.serverMuteState}
      isModerator={isModerator}
      media={media}
      devices={devices}
      isConnected={isConnected}
    />
  );
}
export {
  ConnectedComponent as AudioButtonContainer
}
export default FunctionalWrapper;

